<!-- TODO remove this commented out code. This is only a reference until the ticket TC-326 is closed. -->
<!--<template lang="pug">-->
<!--    #app-->
<!--        I18nInitializer-->
<!--            component(:is="currentOverlay" :overlaydata="currentOverlayData" v-if="currentOverlay" :lang="lang" :setLang="setLang")-->
<!--            component(:is="currentPage" :pagedata="currentPageData" :lang="lang" :setLang="setLang")-->

<!--</template>-->
<template>
  <div id="app">
    <MaintenanceView v-if="inMaintenanceMode"/>
    <I18nInitializer v-else>
      <component :is="currentOverlay" :overlaydata="currentOverlayData" v-if="currentOverlay" />
      <router-view></router-view>
    </I18nInitializer>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import LoginOptions from './components/pages/LoginOptions.vue';
import Login from './views/auth/LoginView';
import LocationOptions from './components/pages/LocationOptions.vue';
import BenefitsOverview from './components/pages/BenefitsOverview.vue';
import BenefitsCategory from './components/pages/BenefitsCategory.vue';
import BenefitsDetail from './components/pages/BenefitsDetail.vue';
import ProfileOverview from './components/pages/ProfileOverview.vue';
import MoreOverview from './components/pages/MoreOverview.vue';
import TicketsInfoDiscount from './components/pages/TicketsInfoDiscount.vue';
import TicketsInfoResort from './components/pages/TicketsInfoResort.vue';
import TicketsInfoPets from './components/pages/TicketsInfoPets.vue';
import TicketsInfoAnonymous from './components/pages/TicketsInfoAnonymous.vue';
import TicketsInfoBirthday from './components/pages/TicketsInfoBirthday.vue';
import TicketsInfoGuestType from './components/pages/TicketsInfoGuestType.vue';
import TicketsInfoSaveAccount from './components/pages/TicketsInfoSaveAccount.vue';
import BookingView from './views/taxcard/BookingView.vue';
import CheckoutView from './views/checkout/CheckoutView.vue';
import CheckoutPaymentDetailsView from './views/checkout/CheckoutPaymentDetailsView.vue';
import CheckoutPaymentVerifyView from './views/checkout/CheckoutPaymentVerifyView.vue';
import RegisterView from './views/auth/RegisterView.vue';
import RegisterConfirmationView from './views/auth/RegisterConfirmationView.vue';
import RequestPasswordResetView from './views/auth/RequestPasswordResetView.vue';
import PasswordResetView from './views/auth/PasswordResetView.vue';
import TransactionOverviewView from './views/taxcard/TransactionOverviewView.vue';
import TransactionDetailView from './views/taxcard/TransactionDetailView.vue';
import HomePrinterPage from './views/taxcard/transaction/print-overlay/HomePrinterPage.vue';
import BookingRegistrationFormView from './views/taxcard/BookingRegistrationFormView.vue';

import Info from './components/overlays/Info.vue';
import Options from './components/overlays/Options.vue';
import Loading from './components/overlays/Loading.vue';
import AccountDeletion from './components/overlays/AccountDeletion.vue';
import ProofUpload from './components/overlays/ProofUpload.vue';
import SetPassword from './components/overlays/SetPassword.vue';
import SavedPeople from './components/overlays/SavedPeople.vue';
import CouponRedeem from './components/overlays/CouponRedeem.vue';
import CouponDetail from './components/overlays/CouponDetail.vue';
import CouponGuide from './components/overlays/CouponGuide.vue';
import PaymentFrame from './components/overlays/PaymentFrame.vue';
import PublicTransportTicket from './components/overlays/PublicTransportTicket.vue';
import EnterTransferCode from './components/overlays/EnterTransferCode.vue';

import I18nInitializer from '@/components/i18n/I18nInitializer';

import RegistrationFormConfirm from '@/components/overlays/RegistrationFormConfirm';
import LogOut from '@/components/overlays/LogOut';
import FeedbackView from '@/views/feedback/FeedbackView';
import AcceptedCommuneInfo from '@/views/location/AcceptedCommuneInfo';
import MaintenanceView from '@/views/maintenance/MaintenanceView.vue';

export default {
  name: 'app',
  data() {
    return {
      interval: null,
    };
  },
  created() {
    this.$store.dispatch('checkAPIHealth');
  },
  mounted() {
    if (this.inMaintenanceMode) {
      return;
    }
    this.$store.dispatch('locateAndSetCommune');

    this.$store.dispatch('loadUserData').catch(error => console.error('Error while loading userdata:', error));

    this.$store.dispatch('loadCommuneData').catch(error => console.error('Error while loading userdata:', error));

    if (this.loggedInUser) {
      this.$store.dispatch('loadFavorites').catch(error => console.error('Error while loading userdata:', error));
    }

    this.checkSession();

    this.interval = setInterval(() => {
      this.checkSession();
    }, 30000);

    localStorage.setItem('customerUUID', this.$store.state.customerUUID);

    const cardNumber = this.getQuery('cardnumber');
    if (cardNumber) {
      this.showInfo('Ticket erfolgreich gekauft', 'Buchung');
      this.$router.push({ name: this.$namedRoutes.transactionOverview });
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    ...mapActions(['loadCommuneData', 'loadFavorites']),
    ...mapMutations(['changeLocation']),
    checkSession() {
      this.$store.dispatch('loginStatus').then(isLoggedIn => {
        if (!!this.loggedInUser && !isLoggedIn) {
          this.showInfo('Ihre Sitzung ist abgelaufen. Sie werden nun abgemeldet', 'Sitzung abgelaufen', () => {
            this.$store.dispatch('logoutUser');
          });
        }
      });
    },
    getQuery(queryName) {
      let items = window.location.search.substr(1).split('&');
      for (let i = 0; i < items.length; i++) {
        let query = items[i].split('=');
        if (query[0] === queryName && query[1]) return decodeURIComponent(query[1]);
      }
      return null;
    },
    showInfo(message, title, submit) {
      const overlayData = {
        title,
        message,
      };

      if (submit) {
        overlayData.submit = submit;
      }

      this.$store.commit('openOverlay', {
        overlayName: 'Info',
        overlayData: overlayData,
      });
    },
  },
  computed: {
    ...mapGetters([
      'inMaintenanceMode',
      'currentPage',
      'currentPageData',
      'currentOverlay',
      'currentOverlayData',
      'loggedInUser',
      'communeSelected',
    ]),
  },
  watch: {
    // to disable the scrollbar when any overlay is open.
    currentOverlay(name) {
      if (name) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    $route(to, from) {
      const communeId = parseInt(this.$route.params.communeId, 10);
      const lastCommune = this.communeSelected;
      this.changeLocation(communeId);
      if (lastCommune && parseInt(lastCommune, 10) === communeId) {
        return;
      }
      this.loadCommuneData();
    },
  },
  components: {
    MaintenanceView,
    AcceptedCommuneInfo,
    Login,
    LoginOptions,
    LocationOptions,
    BenefitsOverview,
    BenefitsCategory,
    BenefitsDetail,
    Options,
    Info,
    Loading,
    LogOut,
    RegistrationFormConfirm,
    AccountDeletion,
    ProofUpload,
    SetPassword,
    ProfileOverview,
    SavedPeople,
    CouponRedeem,
    CouponDetail,
    CouponGuide,
    MoreOverview,
    TicketsInfoDiscount,
    TicketsInfoResort,
    TicketsInfoPets,
    TicketsInfoAnonymous,
    TicketsInfoBirthday,
    TicketsInfoGuestType,
    TicketsInfoSaveAccount,
    PaymentFrame,
    BookingView,
    CheckoutView,
    CheckoutPaymentDetailsView,
    CheckoutPaymentVerifyView,
    RegisterView,
    RegisterConfirmationView,
    RequestPasswordResetView,
    PasswordResetView,
    TransactionOverviewView,
    TransactionDetailView,
    I18nInitializer,
    BookingRegistrationFormView,
    FeedbackView,
    HomePrinterPage,
    PublicTransportTicket,
    EnterTransferCode,
  },
};
</script>

<style lang="scss" scoped>
#app {
  @media print {
    max-width: none;
  }
}
</style>

<style lang="sass">

*,
*:before,
*:after
  box-sizing: border-box

body
  margin: 0
  padding: 0
  border: none
  font-size: 16px
  font-family: 'Open Sans', sans-serif
  -webkit-font-smoothing: antialiased
  text-rendering: optimizeLegibility

.button
  width: 100%
  padding: 20px
  text-align: center
  margin-top: 20px
  background: #fff
  color: #6F7175
  border-radius: 10px
  box-shadow: 0 0 10px rgba(0, 0, 0, .2)

.iconbutton
  width: 32px
  height: 32px
  padding: 6px
  border-radius: 50px
  color: #1DB2D1
  border: 1px solid #1DB2D1
  margin-right: 10px

input[type="text"],
input[type="password"]
  border-radius: 3px
  border: none
  width: 100%

#app
  max-width: 480px
  margin: 0 auto
  position: relative

a,
a:visited,
a:hover,
a:active
  color: inherit
  text-decoration: none
</style>
